import { cva } from "class-variance-authority";

export const AVATAR_STYLES = {
  root: "relative flex shrink-0 overflow-hidden rounded-full",
  image: "aspect-square h-full w-full",
  fallback: "flex h-full w-full items-center justify-center rounded-full bg-primary text-primary-foreground",
};

export const avatarVariants = cva(AVATAR_STYLES.root, {
  variants: {
    size: {
      sm: "h-8 w-8",
      md: "h-10 w-10",
      lg: "h-12 w-12",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export const avatarFallbackVariants = cva(AVATAR_STYLES.fallback, {
  variants: {
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base",
    },
  },
  defaultVariants: {
    size: "md",
  },
}); 